export default __webpack_public_path__ + "static/media/dubai-silicon-oasis.7891cd70.png";